// 客诉类型
<template>
	<div id="containt">
		<el-tabs v-model="activeName" class="tab-box" @tab-click="handleClick">
			<el-tab-pane label="常规" name="first">
				<editView v-if="showEdit" visible-key="showEdit" @resetEvent="resetEvent" :_dataId.sync="dataId"
					:parent-target="_self" @reload="$reloadHandle"  @goBackIndex="goBackIndex"></editView>
			</el-tab-pane>
			<el-tab-pane label="列表" name="second">
				<div class="grid-height" style="display:flex">
					<!-- 左边------- 树型结构 -->
					<div class="left_tree">

						<div style="padding: 5px;margin: 0px 8px;   max-height: 70vh;
    overflow: hidden;
    overflow-y: scroll;border: 1px solid #ededed;">
							<div class="title"> <svg t="1676961094129" class="icon tree_icon" viewBox="0 0 1024 1024"
									version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2887" width="20" height="20">
									<path
										d="M384 725.333333c0 21.333333 17.066667 38.4 38.4 42.666667H640v-42.666667c0-21.333333 17.066667-38.4 38.4-42.666666H853.333333c25.6 0 42.666667 17.066667 42.666667 42.666666v170.666667c0 25.6-17.066667 42.666667-42.666667 42.666667h-170.666666c-25.6 0-42.666667-17.066667-42.666667-42.666667v-42.666667h-213.333333c-68.266667 0-123.733333-51.2-128-119.466666V341.333333H170.666667c-21.333333 0-38.4-17.066667-42.666667-38.4V128c0-25.6 17.066667-42.666667 42.666667-42.666667h341.333333c25.6 0 42.666667 17.066667 42.666667 42.666667v170.666667c0 25.6-17.066667 42.666667-42.666667 42.666666H384v128h256v-42.666666c0-21.333333 17.066667-38.4 38.4-42.666667H853.333333c25.6 0 42.666667 17.066667 42.666667 42.666667v170.666666c0 25.6-17.066667 42.666667-42.666667 42.666667h-170.666666c-25.6 0-42.666667-17.066667-42.666667-42.666667v-42.666666H384v170.666666z m426.666667 42.666667h-85.333334v85.333333h85.333334v-85.333333z m0-298.666667h-85.333334v85.333334h85.333334v-85.333334z m-341.333334-298.666666H213.333333v85.333333h256V170.666667z"
										fill="#1296db" p-id="2888"></path>
								</svg>

								<span>客诉分类</span>
							</div>
							<el-input placeholder="关键字过滤" v-model="filterText">
							</el-input>

							<el-tree class="tree-line" :data="data" lazy :load="loadChildNode" :props="defaultProps"
								@node-click="handleNodeClick" :filter-node-method="filterNode" ref="tree">
							</el-tree>
						</div>
					</div>
					<div class="table_main" style="height: calc(100vh - -30px);">
						<vxe-grid ref="table-m1" show-overflow height="100%" :stripe="true" border="default" :row-config="{ isHover: true }"
							v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
							@custom="$vxeTableUtil.customHandle">

							<template #form>
								<div class="clearfix screen-btns">
									<div class="fl">
										<vxe-button status="primary" class="button-sty" icon="el-icon-plus"
											@click="openEditDialog" v-if="customerComplaintTypeAdd">新增</vxe-button>
									</div>
									<div class="fr">
<!--										<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"-->
<!--											status="primary" plain>重置</vxe-button>-->
										<vxe-button status="warning" icon="el-icon-search" class="button-sty"
											@click="searchEvent">搜索</vxe-button>
									</div>
								</div>
								<vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
									:data="formData" @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
									<vxe-form-item title="客诉名称:" field="searchName">
										<template v-slot>
											<el-input v-model="searchData.name" size="small" clearable />
										</template>
									</vxe-form-item>
									<vxe-form-item title="客诉编码:" field="searchCode">
										<template v-slot>
											<el-input v-model="searchData.code" size="small" clearable />
										</template>
									</vxe-form-item>
                  <vxe-form-item title="考核类别:" field="searchCode">
                    <template v-slot>
                      <el-select v-model="searchData.checkSubjectId" placeholder="考核类别" clearable>
                        <el-option v-for="item in checkSubjects" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>
								</vxe-form>
							</template>
							<template #pager>
								<pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
							</template>
						</vxe-grid>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import editView from './edit.vue';
import { tableOption } from '@/const/crud/admin/tenant';
import { initVxeTable } from '@/const/crud/admin/table';
import { fetchTree } from "@/api/admin/type_tree";
import request from '@/router/axios'
import pager from '@/components/pager/index.vue'
import {mapGetters} from "vuex";
import {indexPageMixins} from "@/mixins/tabChang";
export default {
	name: 'complain',

  mixins: [indexPageMixins],
	components: { editView, pager },
	data() {
		return {
      customerComplaintTypeEdit: false,
      customerComplaintTypeAdd: false,
      total: 0,
			filterText: '',
			data: [],
			defaultProps: {
				children: 'children',
				label: 'label',
				id: "id",
				isLeaf: "leaf"
			},
			pageSizes: [10, 20, 100],
			//以上树形
			activeName: 'second',
			dataId: 0,
			showEdit: false,
			vxeOption: {},
      searchData: {
        name: null,
        code: null,
        parentId: null,
        checkSubjectId: null
      },
      // searchName:'',
      // searchCode:'',
      // searchCheckSubjectId: null,
      checkSubjects: [],
			// 查询参数
			formData: {
				size: 20,
				current: 1,
				searchCount: false,
        parentId: null,
				// parentId: undefined,
				brandName: "",
				itemCode: "",
				itemName: "",
				bigCategoryId: '',
				smallCategoryId: '',
				id: '',
        name:'',
        code:'',
        checkSubjectId: null
			},
		};
	},
	mounted() {
		// this.getTableData();
    this.loadCheckSubjects()
	},
	watch: {
		filterText(val) {
			this.$refs.tree.filter(val);
		},
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
	},
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    this.customerComplaintTypeEdit = this.permissions['customer_complaint_type_edit']
    this.customerComplaintTypeAdd = this.permissions['customer_complaint_type_add']
  },
	methods: {
		toFilterData() {
          // console.log(55,"触发了搜索");
    // 当用户没有输入内容就按enter键时，就return，不做任何操作，不去搜索
        if(this.formData === '') {
             return
        } else {
        // 请求查询接口，将列表展现出来
            this.searchEvent();
         }
     },
    //初始化加载考核类别
    loadCheckSubjects() {
      this.$http({
        url: '/basic/basCheckSubject/list',
        method: 'get',
        data: {},
        isLoading: true
      }).then(res => {
        this.checkSubjects = [];
        res.data.data.forEach(item => {
          this.checkSubjects.push({
            label: item.name,
            value: item.id
          })
        })
      });
    },
		// 	// 请求总数
		// getNewCount(val){
		// 	console.log(val,"val的值--请求总数");
		// 	this.formData.searchCount=val
		// 	  this.$refs['table-m1'].commitProxy('reload');
		// },
		// // 不请求总数
		// getNewCount2(val){
		// 	console.log(val,"val的值--不请求总数");
		// 	this.formData.searchCount=val
		// 	  this.$refs['table-m1'].commitProxy('reload');
		// },
		// el-tab 监视切换事件
		handleClick(tab, event) {
			console.log(tab, event);

		},

    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

		// 分页功能
		changeTablePage(page, flag) {
			console.log('分页数据', page, this.formData)
			this.formData.size = page.pageSize
			this.formData.current = page.currentPage
			this.formData.searchCount = flag
			this.getTableData();
		},

		filterNode(value, data) {
      console.log(3)
      console.log(data.label);
      console.log(this.data.label)
			if (!value) return true;
			return data.label.indexOf(value) !== -1;
		},
		// 搜索
		searchEvent() {
      this.$objCopy(this.searchData, this.formData)
			this.$refs.pager.clearStoreTableDataTotal()
			this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()

		},
		// 重置
		resetEvent() {
      this.formData.searchCount = false
      this.formData.current= 1
      this.formData.code = ''
      this.formData.name = ''
      this.searchCode = ''
      this.searchName = ''
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
		},
		// 新增
		openEditDialog(id) {
			this.dataId = !id || typeof id == 'object' ? 0 : id;
			this.activeName = 'first';
			this.$openEditView('showEdit');
		},
    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
    },
		// 点击的树形 点
		handleNodeClick(node, data) {
      console.log(node, data, 'click')

      this.formData.parentId = node.id

      this.flushed();

		},

		getTableData() {
			let that = this;
			let tableOption = {
				vue: this,
				tableRef: 'table-m1',
				tableName: 'basic_fault_code_list-m1',
				path: '/basic/basCustomerComplaintType/getListPage',
				param: this.formData,
				method: 'post',

				columns: [
					{ type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left' },
					{
						title: '客诉名称',
						field: 'name',
						width: 150,
						// fixed: 'left'
					},
					{
						title: '客诉编码',
						field: 'code',
						width: 150,
					},

					{
						title: '考核类别',
						field: 'checkSubjectName',
						width: 150,
					},
					{
						title: '客诉层级',
						field: 'level',
						width: 150,
            slots: {
              default: ({ row }) => {
                if (row.level == 0) {
                  return [
                      <span>父级</span>
                  ];
                } else if (row.level == 1) {
                  return [
                      <span>一级</span>
                  ];
                } else if (row.level == 2) {
                  return [
                      <span>二级</span>
                  ];
                }
              }
            }
					},
					{
						title: '客诉父级',
						field: 'parentName',
						width: 150,
					},
					{
						title: '排序',
						field: 'seq',
						width: 80,
					},
					{
						title: '启用',
						field: 'usable',
						width: 150,
						slots: {
							default: ({ row }) => {
								if (row.usable == 0) {
									return [
										<div class="txt-status disable">
											<span>禁用</span>
										</div>
									];
								} else if (row.usable == 1) {
									return [
										<div class="txt-status">
											<span>启用</span>
										</div>
									];
								}
							}
						}
					},


					{
						field: 'createTime',
						title: '创建时间',
						width: 150
					},
					{
						title: '创建人',
						field: 'createBy',
						width: 150,

					},
					{
						width: 47,
						fixed: 'right',
						title: '',
						sortable: false,
						slots: {
							default: ({ row }) => {
								return [
									<div>
										<a
											href="javascript:void(0);"
											class="a-link"
											onclick={() => {
												this.openEditDialog(row.id);
											}}
										>
											<el-tooltip enterable={false} effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
												<i class="el-icon-edit" />
											</el-tooltip>
										</a>
									</div>
								];
							}
						}
					}
				]
			};
			// initVxeTable(tableOption).then(opts => {
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed();
			// console.log(initVxeTable(tableOption),"vxeOption-表头的值及属性");
			// });
		},
		// 加载页面
		loadChildNode(node, resolve) {
      console.log(1)
			const spaceParentGuid = {
				parentId: node.data.id
			}
      request({
        url:'/basic/basCustomerComplaintType/getChildrens',
        method: 'post',
        data: spaceParentGuid
      }).then(({
				data
			}) => {
				console.log(data, "data.data的值");
					resolve(
						data.data.map(item => {
							return {
								label: item.name,
								id: item.id,
								leaf: Number(item.isChild) == 1 ? false : true,
							}
						})
					)
			});
			// this.treeData=data.data


		},
	}
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
	.el-radio__inner {
		border: 0px;
		background: transparent;
	}

	.el-radio__input.is-checked .el-radio__inner {
		background: none;
	}

	.el-radio {
		height: 100%;
		width: 150px;
		position: absolute;
		z-index: 10;
	}
}

.table_main {
	padding-top: 5px;
	padding-left: 5px;
	border: 1px solid #ededed;
	width: calc(100% - 215px);
	border-bottom: none;

	.el-pagination {
		padding: 2px;

	}
}

.left_tree {
	width: 205px;

	.title {
		text-align: left;
		width: 182px;
		padding: 7px 0 5px !important;
		font-size: 13px;
		color: rgba(58, 39, 39, 0.96);

		>span {
			position: relative;
			left: 4px;
			top: -3px;
		}
	}

	::v-deep.el-tree-node__label {
		width: calc(100% - 32px);
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 12px;
		color: rgba(86, 86, 86, 0.96);
	}
}

.tree_icon {
	background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
	.el-tree-node {
		position: relative;
		padding-left: 0px;
	}

	.el-tree-node__content {
		margin-top: 0px;
	}

	.el-tree-node__children {
		padding-left: 16px;
	}

	.el-tree-node::before {
		content: '';
		height: 100%;
		width: 1px;
		position: absolute;
		left: -3px;
		top: -26px;
		border-width: 1px;
		border-left: 1px dashed #d9d9d9;
	}

	.el-tree-node:last-child::before {
		height: 38px;
	}

	.el-tree-node::after {
		content: '';
		width: 24px;
		height: 1px;
		position: absolute;
		left: -3px;
		top: 12px;
		border-width: 1px;
		border-top: 1px dashed #d9d9d9;
	}

	&>.el-tree-node::after {
		border-top: none;
	}

	&>.el-tree-node::before {
		border-left: none;
	}

	.el-tree-node__expand-icon {
		font-size: 17px;

		// color: #000;
		&.is-leaf {
			color: transparent;
			// display: none;
		}
	}
}</style>
